import React from "react";
import { Pagination } from "react-bootstrap";

const CustomPagination = ({ pagination, pageHandler }) => {

  if (!pagination || pagination.totalPages <= 1) {
    return null;
  }

  const { page, totalRecords, totalPages, limit } = pagination;


  const getPageItems = () => {

    const items = [];

    const startPage = Math.max(1, page - 2);
    const endPage = Math.min(totalPages, page + 2);

    // FIRST PAGE
    if (startPage > 1) {

      items.push(
        <Pagination.Item
          key={1}
          onClick={() => pageHandler(1)}
        >
          1
        </Pagination.Item>
      );

      // START ...
      if (startPage > 2) {
        items.push(
          <Pagination.Ellipsis
            key="start-ellipsis"
            disabled
          />
        );
      }
    }

    // MIDDLE PAGES
    for (let i = startPage; i <= endPage; i++) {

      items.push(
        <Pagination.Item
          key={i}
          active={i === page}
          onClick={() => pageHandler(i)}
          className="cursor-pointer rounded-3"
        >
          {i}
        </Pagination.Item>
      );
    }

    // LAST PAGE
    if (endPage < totalPages) {

      // END ...
      if (endPage < totalPages - 1) {

        items.push(
          <Pagination.Ellipsis
            key="end-ellipsis"
            disabled
          />
        );
      }

      items.push(
        <Pagination.Item
          key={totalPages}
          onClick={() => pageHandler(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    return items;
  };


  return (
    <div className="gc-pagination px-2">

    
      <small>
        Showing {(page - 1) * limit + 1} to  {totalRecords > page * limit ? page * limit : totalRecords} of {totalRecords} results
      </small>

      <Pagination size="sm"> 

        <Pagination.Prev
          disabled={page === 1}
          onClick={() => pageHandler(page - 1)}
        />

        {getPageItems()}

        <Pagination.Next
          disabled={page === totalPages}
          onClick={() => pageHandler(page + 1)}
        />

      </Pagination>

    </div>
  );
};

export default React.memo(CustomPagination);